/*
 *  I16DIMADOUCISSEURECSI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-19 12:44:30 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I16DIMADOUCISSEURECS_SECTION_0_TITLE: "Dimensionnez le volume de résine en fonction de vos consommations d'eau chaude sanitaire",
  I16DIMADOUCISSEURECS_in_thEauVille: 'Th° eau de ville',
  I16DIMADOUCISSEURECS_in_thSouhaite: 'Th° souhaité',
  I16DIMADOUCISSEURECS_I01EVACONSSYSTECS: 'Calculer avec la page ECS ou saissisez manuellement',
  I16DIMADOUCISSEURECS_in_consommation: "Consommation d'eau",
  I16DIMADOUCISSEURECS_cpcTraitementLitreResine_uuid: 'Efficacité de la résine',
  I16DIMADOUCISSEURECS_in_resineSouhaite: 'Nombre de litre de résine souhaité',
  I16DIMADOUCISSEURECS_SECTION_1_TITLE: 'Caractéristiques de la résine et du bac',
  I16DIMADOUCISSEURECS_res_cpcTraitementResine: 'Capacité de traitement de la résine',
  I16DIMADOUCISSEURECS_res_traitementPrevoir: 'Traitement à prévoir',
  I16DIMADOUCISSEURECS_res_freqRegen: 'Fréquence de régénération',
  I16DIMADOUCISSEURECS_res_consoSalt: 'Consommation de sel par régénération',
  I16DIMADOUCISSEURECS_res_consoEauRenvoie: "Consommation d'eau de renvoie",
  I16DIMADOUCISSEURECS_res_tauxSodiumEau: "Taux de sodium dans l'eau"
}
